import fp from 'lodash/fp';
import React from 'react';
import { VariableSizeGrid, GridChildComponentProps } from 'react-window';

import { cn, Text } from 'Modules/ui';

import { GridAdapter } from '../GridAdapter';
import { cellStyles } from '../Cells';
import { FilterItemProps, FiltersProps } from './types';
import styles from './index.module.scss';


const filtersRenderer = React.memo<GridChildComponentProps<FilterItemProps>>(({
    style,
    columnIndex,
    data: { columns, className },
}) => {
    const { Header, Cell, filterField = {}, fixedWidth, ...column } = columns[columnIndex];
    const Filter = filterField.Component;
    return (
        <Text
            className={cn(
                cellStyles.cell,
                filterField.className,
                className,
                columnIndex === columns.length - 1 && cellStyles.last,
            )}
            component='div'
            ellipsis
            style={style}
        >
            {Filter ? <Filter column={column} /> : null}
        </Text>
    );
});

export const Filters = React.forwardRef<VariableSizeGrid, FiltersProps>(({
    height,
    columns,
    classNames,
    ...props
}, ref) => (
    <GridAdapter
        ref={ref}
        height={height}
        className={cn(styles.container, classNames.container)}
        rowCount={1}
        rowHeight={fp.constant(height)}
        columnCount={columns.length}
        itemData={{
            columns,
            className: classNames.cell,
        }}
        {...props}
    >
        {filtersRenderer}
    </GridAdapter>
));
